const config = {
  apiBaseUrl: 'https://backup-api.eswacaaonline.com/api',
  fileBaseUrl: 'https://backup-api.eswacaaonline.com',
  // apiBaseUrl: 'http://127.0.0.1:3000/api',
  //fileBaseUrl: 'http://127.0.0.1:3000',
};

export default config;
